import React from 'react';
import Spinner from '../../../components/Spinner';
import Box from '../../../components/Box';

class LoginForm extends React.Component {
  handleSubmit = (e) => {
    const email = this.refs.email.value;
    const password = this.refs.password.value;

    e.preventDefault();

    // TODO: email validation
    if (email !== '' && password !== '') {
      this.props.onSubmit(email, password);
    }
  };

  render() {
    const { errorMsg, isFetching } = this.props;

    return (
      <div className="row">
        <div className="col-xs-6 col-xs-offset-3">
          <form role="form" onSubmit={ this.handleSubmit }>
            { isFetching && <Spinner/> }
            <Box title="Login"
                 footer={ <button className={ "btn btn-default" + ( isFetching ? ' disabled' : '' ) }>Submit</button> }>
              { (errorMsg !== '') &&
                <div className="form-group has-error">
                  <span className="help-block">{ errorMsg }</span>
                </div>
              }
              <div className="form-group">
                <label htmlFor="inputEmail">Email address</label>
                <input type="email" ref="email" className="form-control" id="inputEmail" placeholder="Enter email"/>
              </div>
              <div className="form-group">
                <label htmlFor="inputPassword">Password</label>
                <input type="password" ref="password" className="form-control" id="inputPassword" placeholder="Password"/>
              </div>
            </Box>
          </form>
        </div>
        {/* /.col */}
      </div>
    );
  }
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/core/components/LoginForm/LoginForm.js